import { useEffect, useRef } from "react";

import { Burger } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconBrandWhatsapp } from "@tabler/icons-react";
import ModalPop from "../../home/ModalPop";

export const HeaderCategoryList = [
  {
    id: 1,
    title: "스마트\u00A0누수",
    sub: "(장인누수)",
    link: "#about",
  },
  {
    id: 2,
    title: `서비스\u00A0목록`,
    link: "#service",
  },
  {
    id: 3,
    title: `작업사례`,
    sub: "(BLOG)",
    link: "#blog",
  },
  {
    id: 4,
    title: `긴급출동`,
    sub: "(365일 24시간)",
    link: "#contact",
  },
];

const MHeader = () => {
  const [opened, { toggle }] = useDisclosure(false);

  const phoneMenuListRef = useRef<HTMLDivElement>(null);
  const burgerIconRef = useRef<HTMLButtonElement>(null);
  const headerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    burgerIconRef.current?.addEventListener("click", () => {
      opened
        ? (phoneMenuListRef.current!.style.transform = "translate(0, -120%)")
        : (phoneMenuListRef.current!.style.transform = "translate(0, 0)");
    });
  }, [opened]);

  const menuOnclick = (link: string) => {
    let menuHeight =
      document.querySelector<HTMLDivElement>("#header")!.offsetHeight;

    var location = document.querySelector<HTMLDivElement>(link)!.offsetTop;

    window.scrollY &&
      window.scrollTo({
        top: location - menuHeight + 120,
        behavior: "smooth",
      });
  };

  const phoneMenuOnclick = (link: string) => {
    let menuHeight =
      document.querySelector<HTMLDivElement>("#header")!.offsetHeight;

    var location = document.querySelector<HTMLDivElement>(link)!.offsetTop;

    window.scrollY &&
      window.scrollTo({
        top: location - menuHeight,
        behavior: "smooth",
      });

    toggle();
    phoneMenuListRef.current!.style.transform = "translate(0, -100%)";
  };

  const popupRef = useRef<HTMLDivElement>(null);

  const openfunc = () => {
    popupRef.current!.style.display = "block";
  };

  const closefunc = () => {
    popupRef.current!.style.display = "none";
  };

  return (
    <>
      <ModalPop popupRef={popupRef} closefnc={closefunc} />
      <header className="fixed left-0 top-0 w-full h-fit z-40">
        <div
          ref={headerRef}
          id="header"
          className="relative w-full h-fit px-2 lg:pl-[calc((100%-var(--container))/4)] lg:pr-0 max-h-20 lg:max-h-32 overflow-hidden bg-white z-40"
        >
          <div className="relative w-full h-full flex justify-between items-center gap-6 xl:gap-4 pt-2 lg:pt-0">
            <Burger
              ref={burgerIconRef}
              opened={opened}
              onClick={toggle}
              className="block xl:hidden"
              size="md"
              color="blue"
            />
            <div className="relative w-auto h-full">
              <img
                alt="스마트장인누수 로고"
                onClick={() => (window.location.href = "/")}
                className="!relative w-auto h-full max-h-12 lg:max-h-14 xl:max-h-16 py-1 object-contain cursor-pointer"
                src="/images/logo.png"
                width={341}
                height={113}
              />
            </div>
            <div className="block xl:hidden relative w-fit h-fit p-1 mx-1 rounded-full">
              <IconBrandWhatsapp
                onClick={() => {
                  window.location.href = "tel:010-8912-1202";
                }}
                size={30}
                stroke={1}
                className="text-primary"
              />
            </div>
            <ul className="hidden relative w-fit h-fit text-center xl:flex justify-around items-start justify-items-center gap-14 xl:gap-24 3xl:gap-32 cursor-pointer">
              {HeaderCategoryList.map((v, i) => (
                <li
                  key={i + "pc"}
                  onClick={() => menuOnclick(v.link)}
                  className="text-center relative w-fit h-fit"
                >
                  <p className="text-base xl:text-xl !leading-tight">
                    {v.title}
                    <br />
                    <span className="text-sm xl:text-base">{v.sub}</span>
                  </p>
                </li>
              ))}
            </ul>
            <div className="hidden xl:grid relative w-fit h-full grid-cols-2">
              <img
                onClick={openfunc}
                className="!relative w-auto h-full max-h-28 object-contain cursor-pointer"
                alt="실시간 상담 신청"
                src={"/images/headerBtn1.png"}
                width={368}
                height={229}
              />
              <div>
                <img
                  onClick={() => {
                    window.location.href = "tel:010-8912-1202";
                  }}
                  className="!relative w-auto h-full max-h-28 object-contain cursor-pointer"
                  alt="전화 상담 010-8912-1202"
                  src={"/images/headerBtn2.png"}
                  width={368}
                  height={229}
                />
              </div>
            </div>
          </div>
        </div>
        <div
          ref={phoneMenuListRef}
          className="block xl:hidden fixed top-[50px] left-0 w-full h-full -translate-y-full transition-transform duration-500 z-30"
        >
          <ul className="border-b bg-white text-font">
            {HeaderCategoryList.map((v, i) => (
              <li
                key={i}
                onClick={() => phoneMenuOnclick(v.link)}
                className="border-b py-4 text-center"
              >
                <p className={i === 0 ? "text-base font-black" : "text-base"}>
                  {v.title}
                </p>
              </li>
            ))}
          </ul>
        </div>
      </header>
    </>
  );
};

export default MHeader;
